module.exports = __webpack_public_path__ + "static/img/streamMedia-benefit4.7a57d03.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/promotion/streamMedia-benefit4.png
// module id = 1093
// module chunks = 1